// extracted by mini-css-extract-plugin
export var twoColImages = "styles-module--two-col-images--1oDPN";